import { render } from "./TestResult.vue?vue&type=template&id=4dbbe804&scoped=true"
import script from "./TestResult.vue?vue&type=script&lang=js"
export * from "./TestResult.vue?vue&type=script&lang=js"

import "./TestResult.vue?vue&type=style&index=0&id=4dbbe804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbbe804"]])

export default __exports__